import {SEARCH_LIST_RELOAD} from '../actionType';

export default function (state = {}, action) {
    switch (action.type) {
        case SEARCH_LIST_RELOAD:
            return {
                ...state,
                keyword: action.keyword,
            };
        default:
            return state;
    }
}